// Tempo en volgorde van het afspelen van de opbouw in de 3D-viewer (O77, O99). Zonder DOM, zodat
// de tests het kunnen draaien (src/modules/3d/opbouw.test.ts).

/** Rustig tempo per stap, samen hoogstens ongeveer 12 seconden van stap 1 tot het einde. */
export const STAP_MS = 1000;
export const MIN_STAP_MS = 250;
export const MAX_AFSPEEL_MS = 12_000;

/** Wachttijd per stap bij dit aantal stappen. */
export function stapDuur(aantal: number): number {
  const overgangen = Math.max(1, aantal - 1);
  return Math.max(MIN_STAP_MS, Math.min(STAP_MS, Math.floor(MAX_AFSPEEL_MS / overgangen)));
}

/** De knop Bouwvolgorde: van stap 1 tot de laatste stap (indexen, 0 is stap 1). */
export function volgordeKnop(aantal: number): number[] {
  return Array.from({ length: Math.max(0, aantal) }, (_, i) => i);
}

/** De schroeven van een stap (O-134a): eerst het hout, dan vliegen ze er kort na elkaar in. */
/** Zo lang vaden de nieuwe onderdelen van een stap in. */
export const OVERGANG_MS = 350;
/** De schroeven beginnen pas als het hout helemaal staat. */
export const VLIEG_START_MS = OVERGANG_MS;
export const VLIEG_MS = 300;
export const VLIEG_TUSSEN_MS = 90;

/**
 * Wanneer elke schroef begint (ms na het begin van de stap) en hoe lang de vlucht duurt. Past dat niet in
 * `beschikbaarMs` (de tijd tot de volgende stap), dan gaat alles in dezelfde verhouding sneller.
 */
export function schroefVlucht(aantal: number, beschikbaarMs: number): { starts: number[]; duur: number } {
  if (aantal <= 0) return { starts: [], duur: VLIEG_MS };
  const totaal = VLIEG_START_MS + VLIEG_TUSSEN_MS * (aantal - 1) + VLIEG_MS;
  const f = beschikbaarMs > 0 && totaal > beschikbaarMs ? beschikbaarMs / totaal : 1;
  return {
    starts: Array.from({ length: aantal }, (_, i) => Math.round((VLIEG_START_MS + VLIEG_TUSSEN_MS * i) * f)),
    duur: Math.round(VLIEG_MS * f),
  };
}

/** Hoe lang de viewer bij positie `pos` van de volgorde blijft staan. */
export function wachtBij(volgorde: readonly number[], pos: number, aantal: number): number {
  return stapDuur(aantal);
}
